/* assets/mad-glass-checkout.js: the glass notice before Check out (Seth 2026-10-14; snippets/mad-glass-checkout.liquid).
   The box is required and belongs to the cart form, so the browser stops Check out while it is unticked even without
   this script. This adds, through listeners on the document (bound once, so a redrawn cart or tray stays covered):
   - invalid: plain words next to the box instead of the browser's bubble, the box brought into view and focused;
   - change: ticked, the answer is saved at once as the cart attribute "Glass notice accepted" (Yes: and the door
     codes), so it reaches the order whichever way the buyer pays; unticked, it is cleared. The same box in the tray
     and on the cart page follow each other. Never throws, never blocks anything else. */
(function () {
  'use strict';
  if (window.madGlassCheckoutBound) return;
  window.madGlassCheckoutBound = true;
  var TICK = '[data-mad-glass-checkout-tick]';
  var FALLBACK = 'Please tick the box to confirm you have read the glass notice, then choose Check out again.';
  var ATTRIBUTE = 'Glass notice accepted';

  function isTick(el) { return !!(el && el.matches && el.matches(TICK)); }
  function hostOf(tick) { return tick.closest('[data-mad-glass-checkout]'); }
  function say(tick, words) {
    var host = hostOf(tick);
    if (!host) return;
    var msg = host.querySelector('[data-mad-glass-checkout-error]');
    if (msg) { clearTimeout(msg.madTimer); msg.textContent = ''; }
    if (!words) { host.removeAttribute('data-tone'); tick.removeAttribute('aria-invalid'); return; }
    host.setAttribute('data-tone', 'error');
    tick.setAttribute('aria-invalid', 'true');
    /* emptied first and written a moment later, so a screen reader announces every blocked tap */
    if (msg) msg.madTimer = setTimeout(function () { if (!tick.checked) msg.textContent = words; }, 50);
  }
  function reduced() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  function save(value) {
    try {
      var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
      var attributes = {};
      attributes[ATTRIBUTE] = value;
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () { /* the Check out form still carries the tick */ });
    } catch (e) { /* never break the cart */ }
  }

  document.addEventListener('invalid', function (e) {
    var tick = e.target;
    if (!isTick(tick)) return;
    try {
      e.preventDefault();
      var host = hostOf(tick);
      say(tick, (host && host.getAttribute('data-mad-glass-message')) || FALLBACK);
      if (host) {
        try { host.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' }); } catch (err) { host.scrollIntoView(); }
      }
      tick.focus({ preventScroll: true });
    } catch (err) { /* the browser's own bubble shows instead */ }
  }, true);

  document.addEventListener('change', function (e) {
    var tick = e.target;
    if (!isTick(tick)) return;
    try {
      say(tick, '');
      var all = document.querySelectorAll(TICK);
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== tick && all[i].value === tick.value) { all[i].checked = tick.checked; say(all[i], ''); }
      }
      save(tick.checked ? tick.value : '');
    } catch (err) { /* ignore */ }
  });
})();
